module.exports = __webpack_public_path__ + "static/media/springville_PH1_bg.74360eaf.webp";